import React from 'react';

import ListaPacientesPainel from './ListaPacientes';

interface IUrlParams {
  token: string;
}
const Painel: React.FC = () => {
  return (
    <>
      <ListaPacientesPainel />
    </>
  );
};

export default Painel;
